"use client";

import { useViewportScrollbarVisibility } from "@/hooks";

/**
 * Renders nothing; only runs the viewport scrollbar visibility hook so the main
 * scrollbar fades in on scroll and fades out when idle (macOS-like).
 */
export function ViewportScrollbarTrigger() {
  useViewportScrollbarVisibility();
  return null;
}
